import { SingleSlider } from '@eti/components';
import type { FilterType } from '@eti/schema-types';
import Filter from './Filter';
import { roundDown, roundUp } from './utils/searchFilters';
import type { Filters } from './v3/MobileFilters';

const ResetAt = {
  MAX: 'MAX',
  MIN: 'MIN',
} as const;

type ResetAtType = (typeof ResetAt)[keyof typeof ResetAt];

const isSelected = (selectedValue: number, maxValue: number) => {
  return selectedValue !== maxValue;
};

type ValueSliderFilterProps = {
  className: string;
  formatDisplayedValue: (value: number) => any;
  isInitiallyExpanded: boolean;
  isToggleable: boolean;
  label: string;
  maxValue: number;
  minValue: number;
  name: typeof FilterType.TravelTime;
  onFilter: (filter: any) => void;
  selectedValue: Filters[typeof FilterType.TravelTime];
  step: number;
  resetAt?: ResetAtType;
};

const ValueSliderFilter = ({
  className,
  isInitiallyExpanded,
  isToggleable,
  formatDisplayedValue = (value) => value,
  label,
  maxValue,
  minValue,
  name,
  onFilter,
  resetAt = ResetAt.MAX,
  selectedValue,
  step = 1,
}: ValueSliderFilterProps) => {
  const roundedMin = roundDown(minValue, step);
  const roundedMax = roundUp(maxValue, step);
  const resetValue = resetAt === ResetAt.MAX ? roundedMax : roundedMin;
  const handleValues = selectedValue ? [selectedValue] : [resetValue];

  const handleReset = () => {
    onFilter({ [name]: null });
  };

  const handleChange = (values: number[]) => {
    if (!isSelected(values[0], resetValue)) {
      handleReset();
    } else {
      onFilter({ [name]: values[0] });
    }
  };

  return (
    <Filter
      className={className}
      isInitiallyExpanded={isInitiallyExpanded}
      isSelected={isSelected(handleValues[0], resetValue)}
      isToggleable={isToggleable}
      label={label}
      name={name}
      onReset={handleReset}
    >
      <SingleSlider
        formatDisplayedValue={formatDisplayedValue}
        handleValues={handleValues}
        handleValuesChange={handleChange}
        initialValue={roundedMax}
        maxValue={roundedMax}
        minValue={roundedMin}
        step={step}
      />
    </Filter>
  );
};

export default ValueSliderFilter;
